// ATC button
// if(customElements.get("button-atc") === undefined) {
//   class ButtonATC extends HTMLElement {
//     constructor() {
//       super();
//       // Identifiers
//       this.identifier = '[data-var-id]';
//       this.bisIdentifier = '#SI_trigger:not(.plug-notice__notify)'; // Exclude plug-notice__notify button
//       this.quantityIdentifier = '[data-quantity]';
//       this.variantsDomIdentifier = '#pdp-variants'; 
//       this.bundleIdentifier = '[data-bundle]';

//       // event to be triggered for id change
//       this.triggerBy = this.dataset.trigger;
//       this.activeId = Number(this.dataset.varId);
//       this.buttons = document.querySelectorAll(this.identifier);
//       this.variants = JSON.parse(document.querySelector('#pdp-variants').textContent);
//       this.active_variant = this.variants.filter(variant => variant.id === this.activeId)[0];
//       this.active_variant_available = this.active_variant.available;

//       this.bis_id = document.querySelectorAll(this.bisIdentifier);

//       // Search for bundle checkbox
//       this.bundle_id = document.querySelector('[data-bundle]');

//       // Search for 'quantity' input or default to 1
//       // !! For now this will always be 1 as we don't have a quantity input
//       this.quantity = document.querySelectorAll(this.quantityIdentifier);
      
//       if(this.quantity.length <= 0) {
//         this.quantity = 1;
//       }
//     }

//     connectedCallback() {
//       // enable button when button loads
//       this.removeAttribute('disabled');

//       if(this.triggerBy) {
//         document.addEventListener(this.triggerBy, this.idChange);
//       }

//       this.addEventListener('click', this.addToCart);
//     }

//     idChange = (e) => {
//       // if no variant is selected, do nothing
//       if(!e.detail.variant) {
//         return;
//       }

//       this.active_variant = e.detail.variant;
//       const id = e.detail.variant.id;
//       this.active_variant_available = this.active_variant.available;
//       this.buttons.forEach(button => {
//         this.activeId = id;
//         button.dataset.varId = id;
//       });
      
//       if(this.active_variant_available === false) {
//         this.bis_id.forEach(id => {
//           this.setButtonsAvailability(id, false, 'block', 'none');
//         });
//       } else {
//         this.bis_id.forEach(id => {
//           this.setButtonsAvailability(id, true, 'none', 'flex');
//         });
//       }

//     }

//     disconnectedCallback() {
//       // browser calls this method when the element is removed from the document
//       // (can be called many times if an element is repeatedly added/removed)
//     }

//     addToCart(e) {
//       e.preventDefault();
//       if(this.active_variant_available) {
//         const items = {
//           "items": [
//             {
//               "id": this.active_variant.id,
//               "quantity": this.quantity
//             },
//           ]
//         }

//         let ids = this.bundle_id?.getAttribute('data-bundle');

//         if(ids)
//           ids = ids.split(',')

//         if(this.bundle_id && this.bundle_id.checked) {
//           ids.forEach(id => {
//             items.items.push({
//               "id": id,
//               "quantity": 1
//             })
//           })
//         }

//         fetch('/cart/add.js', {
//           method: 'POST',
//           body: JSON.stringify(items),
//           headers: {
//             'Content-Type': 'application/json'
//           }
//         })
//         .then(response => {
//           return response.json();
//         }).then(data => {
//           // go to cart page
//           window.location.href = `${Shopify.routes.root}cart`;
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         });
//       }
//     }

//     setButtonsAvailability(id, set, idDisplay, thisDisplay) {
//       id[set === true ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
//       id.style.display = idDisplay;
//       this.style.display = thisDisplay;
//       this[set === true ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
//     }
//   } 
//   customElements.define("button-atc", ButtonATC);
// }

var specialTypesToDisable = []

if(customElements.get("pdp-options") === undefined) {
  // !! MAKE all options in page have same active class
  class PDPOptions extends HTMLElement {
    constructor() {
      super();
      // Search for 'data-id-variant' option or options
      // Get all DOM elements with data-variant-option (variants)
      this.activeClass = 'atc-option--active';
      this.notAvailableClass = 'atc-option--not-available';
      this.optionClass = 'atc-option';
      this.optionSelectors = 'data-variant-option';
      this.priceTarget = '.global-price';
    }

    connectedCallback() {
      // This is the ID of the variant needed on ATC component
      this.variants = this.querySelectorAll(`[${this.optionSelectors}]`);

      // Get JSON variants from script
      this.variant_options = JSON.parse(document.querySelector('#pdp-variants').textContent);
      this.option_size = this.variant_options[0].options.length;

      // Get the type of options (color, size, etc)
      this.variant_type = this.querySelector('[data-option]').dataset.option;

      // Get the first available variant from script
      this.active_variant = this.variant_options.filter(variant => variant.available)[0];
      
      this.setActiveVariant(null, false);

      this.variants.forEach(option =>
        option.addEventListener('click', (e) => this.setActiveVariant(e.target)));
    }

    setActiveVariant = (target, setNew = true) => {
      this.variants.forEach(option => option.classList.remove(this.activeClass));

      if(target) {
        if(!target.classList.contains(this.optionClass)) {
          target = target.closest(`.${this.optionClass}`);
        }
      }

      
      if(target?.classList.contains(this.notAvailableClass)) {
        if(target.previousElementSibling) {
          target = target.previousElementSibling;
        } else if(target.nextElementSibling) {
          target = target.nextElementSibling;
        }
      };

      if(setNew) {
        const activeOption = target.getAttribute(this.optionSelectors);
        const activeTarget = `[data-variant-option="${activeOption}"]`;
        
        document.querySelectorAll(activeTarget)
          .forEach(el => {
            // Selecting all elements but the activeTarget
            el.parentElement.querySelectorAll(`.${this.optionClass}:not(${activeTarget})`).forEach(e => {
              e.classList.remove(this.activeClass);
            })

            el.classList.add(this.activeClass);
          });

        this.setNewVariant();
        this.setPrice(target);
      } else {
        if(this.active_variant){
          this.active_variant.options.forEach(option => {
            const element = document.querySelectorAll(`[data-variant-option="${option}"]`);
            element.forEach(el => el.classList.add(this.activeClass));
          });
        } else {
          // If no variant is selected (all not available) get the first one
          document.querySelector(`[data-variant-option]`).classList.add(this.activeClass);
        }

        // IF active this will slide to the image with the first available or selected variant
        // this.slideToImage();
      }

      this.setInactiveVariants();
    }

    getActiveOptions() {
      let activeVariants = document[this.option_size > 1 ? 'querySelectorAll' : 'querySelector'](`.${this.activeClass}`);
      if(this.option_size > 1) {
        activeVariants = Array.from(activeVariants).slice(0, this.option_size);
      }
      
      // Get the active variant option name ["White"], ["White, "Women", "XS"]
      activeVariants = this.option_size > 1 ?
      Array.from(activeVariants).map(variant => variant.dataset.variantOption)
      : activeVariants.dataset.variantOption;

      return activeVariants;
    }

    setInactiveVariants() {
      // remove not available classes
      const activeOptions = document.querySelectorAll(`.${this.notAvailableClass}`);
      activeOptions.forEach(el => el.classList.remove(this.notAvailableClass));

      if (!this.active_variant) return;

      const option1Options = {}
      const option2Options = {}
      const option3Options = {}

      // Build option relationships for 2-option logic (keeping original working)
      this.variant_options.forEach(variant => {
        if(!option1Options[variant.option1]) option1Options[variant.option1] = []
        option1Options[variant.option1].push(variant.option2)
      });

      this.variant_options.forEach(variant => {
        if(!option2Options[variant.option2]) option2Options[variant.option2] = []
        option2Options[variant.option2].push(variant.option1)
      });

      // Add support for option3 if it exists
      if (this.option_size >= 3) {
        this.variant_options.forEach(variant => {
          if(!option3Options[variant.option3]) option3Options[variant.option3] = []
          option3Options[variant.option3].push({option1: variant.option1, option2: variant.option2})
        });
      }

      // Use original logic for 2-option relationships  
      const inactiveOptions1 = this.getInactiveVariants(option1Options, 'option1');
      const inactiveOptions2 = this.getInactiveVariants(option2Options, 'option2');
      
      // For 3+ options, we need to check combinations more carefully
      if (this.option_size >= 3) {
        // For option1 and option2, only mark as inactive if NO combination with option3 is available
        if(inactiveOptions1[this.active_variant.option1]) {
          inactiveOptions1[this.active_variant.option1].forEach(option => {
            // Check if there's ANY available variant with current option1 + this option2 + any option3
            const hasAnyAvailableVariant = this.variant_options.some(variant => 
              variant.available && 
              variant.option1 === this.active_variant.option1 && 
              variant.option2 === option
            );
            
            if (!hasAnyAvailableVariant) {
              const element = document.querySelectorAll(`[data-variant-option="${option}"]`);
              element.forEach(el => el.classList.add(this.notAvailableClass));
            }
          });
        }

        if(inactiveOptions2[this.active_variant.option2]) {
          inactiveOptions2[this.active_variant.option2].forEach(option => {
            // Check if there's ANY available variant with this option1 + current option2 + any option3
            const hasAnyAvailableVariant = this.variant_options.some(variant => 
              variant.available && 
              variant.option1 === option && 
              variant.option2 === this.active_variant.option2
            );
            
            if (!hasAnyAvailableVariant) {
              const element = document.querySelectorAll(`[data-variant-option="${option}"]`);
              element.forEach(el => el.classList.add(this.notAvailableClass));
            }
          });
        }

        // For option3 (sizes), check exact combinations
        Object.keys(option3Options).forEach(option3Value => {
          const hasAvailableVariant = this.variant_options.some(variant => 
            variant.available && 
            variant.option1 === this.active_variant.option1 && 
            variant.option2 === this.active_variant.option2 && 
            variant.option3 === option3Value
          );
          
          if (!hasAvailableVariant) {
            const element = document.querySelectorAll(`[data-variant-option="${option3Value}"]`);
            element.forEach(el => el.classList.add(this.notAvailableClass));
          }
        });
      } else {
        // Original 2-option logic
        if(inactiveOptions1[this.active_variant.option1]) {
          inactiveOptions1[this.active_variant.option1].forEach(option => {
            const element = document.querySelectorAll(`[data-variant-option="${option}"]`);
            element.forEach(el => el.classList.add(this.notAvailableClass));
          });
        }

        if(inactiveOptions2[this.active_variant.option2]) {
          inactiveOptions2[this.active_variant.option2].forEach(option => {
            const element = document.querySelectorAll(`[data-variant-option="${option}"]`);
            element.forEach(el => el.classList.add(this.notAvailableClass));
          });
        }
      }
    }

    getInactiveVariants = (data, option) => {
      const result = {};
      const keys = Object.keys(data);
      keys.forEach((keyA) => {
        const setA = new Set(data[keyA]);
        keys.forEach((keyB) => {
          if (keyA === keyB) return;

          const setB = new Set(data[keyB]);
          const missingInB = [...setA].filter(val => !setB.has(val));
          if (missingInB.length > 0) {
            if (!result[keyB]) result[keyB] = new Set();
            missingInB.forEach(val => result[keyB].add(val));
          }
        });
      });

      // Convert sets to arrays
      const output = {};
      for (const key in result) {
        output[key] = [...result[key]];
      }

      const notAvailableVariants = this.variant_options.filter(variant => !variant.available);
      if(notAvailableVariants.length <= 0) return output;
      notAvailableVariants.forEach(variant => {
        if(!output[variant[option]]) output[variant[option]] = []
        output[variant[option]].push(variant[option === 'option1' ? 'option2' : 'option1'])
      });

      return output;
    }

    setNewVariant = () => {
      const activeVariants = this.getActiveOptions();
      const prevVariant = this.active_variant;
      this.active_variant = this.variant_options.filter(variant => {
        return this.option_size > 1 ?
          JSON.stringify(variant.options.sort()) === JSON.stringify(activeVariants.sort())
          : variant.options.includes(activeVariants) 
      })[0];

      if(!this.active_variant) {
        this.active_variant = prevVariant;
      }

      this.slideToImage();

      this.postVariant();

      this.setInactiveVariants()
    }

    setPrice = (target) => {
      const noPriceChange = document.querySelector('[data-no-price-change]');
      if(noPriceChange) return;
      
      const priceTarget = document.querySelectorAll(this.priceTarget);
      const priceFormat = target.dataset.price;

      let currency = Shopify.currency.active;

      if(currency === 'USD')
        currency = '';

        if(priceTarget.length > 0) 
          priceTarget.forEach(price => 
            price.innerHTML = Shopify.scFormatMoney(this.active_variant.price, priceFormat) + ' ' + currency);
    }

    slideToImage = () => {
      const sliderSelector = this.getAttribute('data-slider');
      if (!sliderSelector) return;

      const variantImageSrc = this.active_variant?.featured_image?.src ||
        this.active_variant?.image?.src ||
        this.active_variant?.featured_media?.preview_image?.src ||
        this.active_variant?.featured_media?.image?.src;

      if (!variantImageSrc) return;

      const activeImageIdentifier = variantImageSrc
        .split('?')[0]
        .split('/')
        .pop()
        .split('.')[0];

      let attempts = 0;
      const slidesInterval = setInterval(() => {
        attempts += 1;
        const sliders = Array.from(document.querySelectorAll(sliderSelector));

        if (!sliders.length || !activeImageIdentifier) {
          if (attempts > 50) clearInterval(slidesInterval);
          return;
        }

        const sliderReady = sliders.some(slider => slider.slides?.length > 0 && typeof slider.goToSlide === 'function');

        if (!sliderReady) {
          if (attempts > 50) clearInterval(slidesInterval);
          return;
        }

        clearInterval(slidesInterval);

        sliders.forEach(slider => {
          slider.slides?.forEach(slide => {
            const slideImage = slide.querySelector('img');
            if (!slideImage?.src?.includes(activeImageIdentifier)) return;
            const index = Number(slide.dataset.slideIndex) || 0;
            slider.goToSlide?.(index);
          });
        });
      }, 100);
    }

    postVariant = () => {
      const hasEvent = this.querySelector('[data-trigger]').dataset.trigger;

      if(hasEvent) {
        this.dispatchEvent(new CustomEvent(hasEvent, { 
          detail: {
            variant: this.active_variant
          },
          bubbles: true,
          cancelable: true
        }));
      }
    }

    disconnectedCallback() {
      // browser calls this method when the element is removed from the DOM
      // (can be called many times if an element is repeatedly added/removed)
    }
  }

  customElements.define("pdp-options", PDPOptions);
}